import React, { Component, Fragment } from "react";
import Index from "../../Components/ProducaoEP/Realizado/Relatorio1/Index";
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Navbar from "../../Components/ProducaoEP/Realizado/UI/Navbar";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioEP from "./menuRelatorioEP";

export default class PageRelatorio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        <div className="col-md-12">
                            <Index />
                        </div>
                    </div>
                </div>
                
            </Fragment>
        )
    }
}